import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UiEventRaised } from '@cmx/shared/feature/platform-configuration';
import { Axis, Dimensions, Legend, MultiSeriesDataWithAxis, Scale } from '../charts.model';
import { FieldType } from '@ngx-formly/core';
import { bubbleChartData } from '../chart.data';

@Component({
  selector: 'cmx-bubble-chart',
  templateUrl: './bubble-chart.component.html',
  styleUrls: ['./bubble-chart.component.scss'],
})
export class BubbleChartComponent extends FieldType implements OnInit {
  @Input() data: MultiSeriesDataWithAxis[] = bubbleChartData || [];

  @Input() dimensions: Dimensions = { width: '', height: '' };
  @Input() allowResize = false;
  @Input() legend: Legend = {
    visible: true,
    title: 'Legend',
    position: 'right' || 'below',
  };
  @Input() axis: Axis = {
    showXAxis: true,
    showYAxis: true,
    xAxisLabel: 'xAxis',
    yAxisLabel: 'yAxis',
    showXAxisLabel: true,
    showYAxisLabel: false,
  };
  @Input() scale: Scale = {
    yMin: 0,
    yMax: 0,
    xMin: 0,
    xMax: 0,
  };
  @Input() maxRadius = 20;
  @Input() minRadius = 5;
  @Input() enableGradient = false;
  @Input() showGridLines = true;
  @Input() tooltipDisabled = false;
  @Input() enableAnimations = true;
  @Input() isFormlyField = true;

  @Output() raiseBubbleChartEvent = new EventEmitter<UiEventRaised>();

  view: [number, number] = [500, 300];

  constructor(private element: ElementRef) {
    super();
  }

  ngOnInit(): void {
    if (this.isFormlyField) {
      this.data = this.to.data || this.data;
      this.allowResize = this.to.allowResize || this.allowResize;

      this.dimensions = this.to.dimensions || this.dimensions;
      this.legend = this.to.legend || this.legend;
      this.axis = this.to.axis || this.axis;
      this.enableAnimations = this.to.enableAnimations || this.enableAnimations;
      this.showGridLines = this.to.showGridLines || this.showGridLines;
      this.tooltipDisabled = this.to.tooltipDisabled || this.tooltipDisabled;
      this.enableGradient = this.to.enableGradient || this.enableGradient;
      this.minRadius = this.to.minRadius || this.minRadius;
      this.maxRadius = this.to.maxRadius || this.maxRadius;
    }
    this.resize(this.dimensions.width, this.dimensions.height);
  }

  onSelect(data: unknown): void {
    this.raiseEvent('bubble-chart-clicked', data, false);
  }

  raiseEvent(eventName: string, data: unknown, isNavigation: boolean): void {
    const eventToRaise: UiEventRaised = { eventName, data, isNavigation };
    if (this.isFormlyField) {
      this.to.getFieldEvent(eventToRaise);
    } else {
      this.raiseBubbleChartEvent.emit(eventToRaise);
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (this.allowResize) if (this.allowResize) this.resize();
  }

  resize(width?: string | number, height?: string | number, timeout = 0) {
    setTimeout(() => {
      const parentElement = this.element.nativeElement.parentElement.parentElement;
      if (parentElement) {
        this.view = [+(width || parentElement.offsetWidth - 30), +(height || parentElement.offsetHeight - 60)];
      }
    }, timeout);
  }
}
